import '../../app.constants'
import '../../services/errors';
import '../../services/globals';
import '../../services/place';
import '../../services/user';

import angular from 'angular';
import { get } from 'lodash';

const module = angular.module('whyline.controllers.capacity-configuration', [
  'whyline.constants',
  'whyline.services.globals',
  'whyline.services.user',
  'whyline.services.errors',
  'whyline.services.place',
]);

const CapacityConfigurationController = (
  SAFE_STATES,
  dialog,
  $translate,
  $rootScope,
  $scope,
  $timeout,
  PlaceService,
  UserService,
  ErrorService,
  $window,
  NotificationService) => {
  /*@ngInject*/

  // Init Controller
  const place = PlaceService.GetCurrent();

  let savedCapacity = get(place, 'capacityControl.configuration.capacity', 0);
  $scope.$window = $window;
  $scope.disabled = !get(place, 'capacityControl.configuration.agendaEnabled');
  $scope.totalCapacity = savedCapacity;
  $scope.total = 0;
  $scope.totalPhysical = 0;
  $scope.totalVirtual = 0;
  $scope.totalVirtualWaiting = 0;
  $scope.urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/;
  $scope.newPeople = null;
  $scope.capacity = savedCapacity;
  $scope.newAgendaShortLink = '';
  $scope.agendaShortLink = '';
  $scope.agendaUrl = '';
  $scope.agendaMessages = get(place, 'capacityControl.configuration.agendaMessages', {});

  const setStats = ({
    agendaEnabled,
    total,
    totalVirtualWaiting,
    totalVirtual,
    totalPhysical,
    agendaShortLink,
    agendaUrl,
  }) => {
    $timeout(() => {
      $scope.disabled = !agendaEnabled;
      $scope.total = total;
      $scope.totalPhysical = totalPhysical;
      $scope.totalVirtual = totalVirtual;
      $scope.totalVirtualWaiting = totalVirtualWaiting;
      $scope.newAgendaShortLink = $scope.agendaShortLink = agendaShortLink || '';
      $scope.agendaUrl = agendaUrl;
    });
  };

  PlaceService.GetStats(place._id).then(setStats);
  $rootScope.$on('place:stats-changed', (e, s) => setStats(s));

  $rootScope.$on('place:capacity-changed', (event, { capacity }) => {
    $timeout(() => {
      $scope.capacity = savedCapacity = $scope.totalCapacity = capacity;
    })
  });

  // Validation: Integer Range
  const validatePositiveInteger = value => {
    if (!value || value < 1 || value > 999999) {
      NotificationService.Error($translate.instant('value_out_of_boundaries'));
      return false;
    }
    return true;
  }

  const validatePeopleWaitng = value => {
    if (value < $scope.totalVirtualWaiting) {
      NotificationService.Warning($translate.instant('capacity_less_than_waiting'));
      return false;
    }
    return true;
  }

  // Validation: URL
  const validateWebSite = () => {
    const website = $scope.newAgendaShortLink;

    if (typeof website === 'undefined' &&
      $scope.capacityConfigurationForm.agendaShortLink.$dirty &&
      $scope.capacityConfigurationForm.agendaShortLink.$error) {
      NotificationService.Error($translate.instant('url regex'));
      return false;
    }

    return true;
  }

  // Validation: Agenda Messages
  const validateAgendaMessages = () => {
    const enableAgendaMessage = get($scope.agendaMessages, 'enable', '');
    const disableAgendaMessage = get($scope.agendaMessages, 'disable', '');
    let valid = true;

    if (enableAgendaMessage.length > 160) {
      NotificationService.Error($translate.instant('enable_agenda_message_too_long'));
      valid = false;
    }

    if (disableAgendaMessage.length > 160) {
      NotificationService.Error($translate.instant('disable_agenda_message_too_long'));
      valid = false
    }

    return valid;
  };

  $scope.blockSaveShortLink = () => {
    return $scope.agendaShortLink === $scope.newAgendaShortLink;
  };

  $scope.blockNewPeopleButtons = () => {
    return null === $scope.newPeople;
  };

  $scope.blockCapacityButtons = () => {
    return savedCapacity === $scope.capacity;
  };

  $scope.blockCompleteCapacityButtons = () => {
    return $scope.total === $scope.totalCapacity;
  };

  $scope.cancelShortLink = () => {
    $scope.newAgendaShortLink = $scope.agendaShortLink;
  };

  $scope.cancelNewPeople = () => {
    $scope.newPeople = null;
  };

  $scope.cancelSetCapacity = () => {
    $scope.capacity = savedCapacity;
  };

  $scope.enableAndFill = () => {
    const disabled = $scope.disabled;
    let message = $translate.instant(disabled ? 'enable_agenda_sure' : 'disable_agenda_sure');

    dialog.confirm(message).then(() => {
      PlaceService.AgendaOnOff(place._id).then(() => {
        PlaceService.FillCapacity(place._id).then(() => {
          message = $translate.instant('success-message');
          NotificationService.Success(message);
        }).catch(ErrorService.handler);
      }).catch(ErrorService.handler);
    });
  }

  $scope.agendaOnOff = () => {
    const disabled = $scope.disabled;
    let message = $translate.instant(disabled ? 'enable_agenda_sure' : 'disable_agenda_sure');

    dialog.confirm(message).then(() => {
      PlaceService.AgendaOnOff(place._id).then(() => {
        message = $translate.instant('success-message');
        NotificationService.Success(message);
      }).catch(ErrorService.handler);
    });
  };

  $scope.fillCapacity = () => {

    if ($scope.blockCompleteCapacityButtons()) {
      return;
    }

    let message = $translate.instant('fill_capacity_sure');

    dialog.confirm(message).then(() => {
      PlaceService.FillCapacity(place._id).then(() => {
        message = $translate.instant('success-fill-capacity');
        NotificationService.Success(message);
      }).catch(ErrorService.handler);
    });
  };

  $scope.saveNewPeople = () => {
    if (validatePositiveInteger($scope.newPeople)) {
      let message = $translate.instant('new_people_sure');

      dialog.confirm(message).then(() => {
        PlaceService.NewPeople(place._id, $scope.newPeople).then(() => {
          $scope.newPeople = null;
          message = $translate.instant('new_people_successfully');
          NotificationService.Success(message);
        }).catch(ErrorService.handler);
      });
    }
  };

  $scope.saveShortLink = () => {
    if (validateWebSite() &&
      $scope.agendaShortLink !== $scope.newAgendaShortLink) {
      let message = $translate.instant('agenda_save_short_link_sure');

      dialog.confirm(message).then(() => {
        PlaceService.SaveShortLink(place._id, $scope.newAgendaShortLink).then(() => {
          $scope.agendaShortLink = $scope.newAgendaShortLink;
          message = $translate.instant('success-message');
          NotificationService.Success(message);
        }).catch(ErrorService.handler);
      });
    }
  };

  $scope.saveAgendaMessages = () => {
    if (validateAgendaMessages()) {
      PlaceService.SaveAgendaMessages(
        place._id,
        $scope.agendaMessages,
        ).then(() => {
          NotificationService.Success($translate.instant('success-message'));
        }).catch(ErrorService.handler);
    }
  };

  $scope.saveCapacity = () => {
    if (validatePositiveInteger($scope.capacity) && validatePeopleWaitng($scope.capacity)) {
      const newCapacity = $scope.capacity;

      if (savedCapacity !== newCapacity) {
        let message = $translate.instant('change_place_capacity_sure');

        dialog.confirm(message).then(() => {
          PlaceService.UpdatePlaceCapacity(place._id, newCapacity).then(() => {
            message = $translate.instant('change_place_capacity_successfully');
            NotificationService.Success(message);
          }).catch(ErrorService.handler);
        });
      }
    }
  };

  $scope.clearCurrentCapacity = () => {
    let message = $translate.instant('clear_capacity_sure');

    dialog.confirm(message).then(() => {
      PlaceService.ClearCurrentCapacity(place._id).then(() => {
        message = $translate.instant('success-message');
        NotificationService.Success(message);
      }).catch(ErrorService.handler);
    });
  };

};

module.exports = module.controller('CapacityConfigurationController', CapacityConfigurationController);
